<template>
  <div class="page-job-list">
    <!-- FILTER -->
    <vs-collapse class="bg-white mb-8 shadow rounded-none">
      <vs-collapse-item class="shadow-none">
        <div slot="header">
          Filter
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
            <DataInput
              v-model="filter.state"
              type="select"
              :options="projectState"
              class="w-full mt-4"
              label="Status"
              name="state"
              allow-null
            />
          </div>
          <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
            <DataInput
              v-model="filter.projectStage"
              type="model"
              class="w-full mt-4"
              label="Projektphase"
              name="projectStage"
              gql-query="vacancyPhases"
              allow-null
            />
          </div>
          <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
            <DataInput
              v-model="filter.consultant"
              type="model"
              class="w-full mt-4"
              label="Berater"
              name="consultant"
              model-label="
                firstName
                lastName"
              :select-label="el => el.firstName + ' ' + el.lastName"
              gql-query="consultantsPage"
              gql-single-query="consultant"
              gql-filter-type="objectFilter"
              allow-null
            />
          </div>
          <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
            <DataInput
              v-model="filter.userGroup"
              type="model"
              class="w-full mt-4"
              label="Benutzergruppe"
              name="userGroup"
              gql-query="userGroups"
              allow-null
            />
          </div>
        </div>

        <!-- VACANCYS FILTER -->
        <div class="vx-row">
          <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
            <DataInput
              v-model="filter.skillJobType"
              type="model"
              class="w-full mt-4"
              label="Berufsgruppe"
              name="skillJobType"
              multiple
              gql-query="applicantSkillJobTypes"
              allow-null
            />
          </div>
          <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
            <DataInput
              v-model="filter.occupation"
              type="model"
              class="w-full mt-4"
              label="Beruf"
              name="occupation"
              gql-query="occupations"
              allow-null
            />
          </div>
          <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
            <DataInput
              v-model="filter.jobType"
              type="model"
              class="w-full mt-4"
              label="Stellenart"
              name="jobType"
              gql-query="vacancyJobTypes"
              allow-null
            />
          </div>
          <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
            <DataInput
              v-model="filter.recruitment"
              type="select"
              :options="[
                { label: 'Ja', code: true },
                { label: 'Nein', code: false },
                { label: 'Alle', code: null }
              ]"
              class="w-full mt-4"
              label="Personalvermittlung"
              name="recruitment"
            />
          </div>
          <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
            <DataInput
              v-model="filter.company"
              type="model"
              class="mt-4"
              label="Firma"
              name="company"
              gql-filter-type="objectFilter"
              gql-query="companies"
              allow-null
            />
          </div>
        </div>
        <div>
          <vs-button color="danger" class="float-right" @click="clearFilter"
            >Filter zurücksetzen</vs-button
          >
        </div>
      </vs-collapse-item>
    </vs-collapse>

    <div v-if="vacancyProjectPage" class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2">
                {{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{ currentPage * paginationPageSize }}
                von {{ vacancyProjectPage.total }}
              </span>
              <feather-icon icon="chevron-down" svg-classes="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(15)">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <DataInput
          v-model="searchQuery"
          type="text"
          placeholder="Suche..."
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          name="searchQuery"
        />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

        <div class="vx-col md:w-3/12 sm:w-1/4 w-full">
          <DataInput
            v-model="filter.company"
            type="model"
            name="company"
            placeholder="Firma"
            gql-filter-type="objectFilter"
            gql-query="companies"
            model-label="
              name
              landwehrId"
            :select-label="el => el.name + ' ' + (el.landwehrId ? '(L1)' : '')"
          />
        </div>
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :column-defs="columnDefs"
        :default-col-def="defaultColDef"
        :row-data="vacancyProjectPage.results"
        row-selection="multiple"
        suppress-row-click-selection="true"
        col-resize-default="shift"
        :animate-rows="true"
        :pagination="true"
        :pagination-page-size="paginationPageSize"
        :suppress-pagination-panel="true"
        :enable-rtl="$vs.rtl"
        @grid-ready="onGridReady"
      />

      <vs-pagination
        v-model="currentPage"
        class="mt-6 md:mt-0"
        :total="totalPages"
        :max="7"
        icon-pack="fas"
        prev-icon="fa-chevron-left"
        next-icon="fa-chevron-right"
      />
    </div>
  </div>
</template>

<script>
import { agridMixin } from "@/mixins/agridMixin.js";
import { paginationMixin } from "@/mixins/paginationMixin.js";
import filterToQueryMixin from "@/mixins/filterToQueryMixin.js";
import gql from "graphql-tag";
import CellRendererActions from "./cell-renderer/CellRendererActions";
import CellRendererStatus from "./cell-renderer/CellRendererStatus";
import DataInput from "@/components/ui/DataInput";
import projectState from "@/data/enums/ProjectState.js";

export default {
  components: {
    DataInput,

    // Cell renderer
    CellRendererStatus, // eslint-disable-line
    CellRendererActions // eslint-disable-line
  },
  mixins: [
    paginationMixin("vacancyProjectPage"),
    agridMixin,
    filterToQueryMixin({
      state: String,
      projectStage: String,
      recruitment: Boolean,
      consultant: String,
      company: String,
      userGroup: String,
      occupation: String,
      skillJobType: Array,
      jobType: String,
      searchQuery: String
    })
  ],
  data() {
    return {
      // Filter Options
      filter: {
        consultant: null,
        company: null,
        userGroup: null,
        occupation: null,
        skillJobType: null,
        jobType: null,
        state: null,
        projectStage: null,
        recruitment: null
      },
      projectState,
      columnDefs: [
        {
          headerName: "",
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          width: 50
        },
        {
          headerName: "Nr",
          field: "number",
          valueFormatter: col => col.value,
          minWidth: 50,
          width: 70
        },
        {
          headerName: "Titel",
          field: "title",
          valueFormatter: col => col.value,
          minWidth: 230
        },
        {
          headerName: "Unternehmen",
          field: "company.name",
          valueFormatter: col => col.value,
          minWidth: 200
        },
        {
          headerName: "Arbeitsort",
          // field: "company.name",
          valueFormatter: col => col.value,
          minWidth: 160
        },
        {
          headerName: "Phase",
          field: "projectStage.name",
          valueFormatter: col => col.value,
          minWidth: 100
        },
        /*{
          headerName: "Veröffentlicht auf",
          field: "company.name",
          valueFormatter: col => col.value,
          minWidth: 200
        },*/
        {
          headerName: "",
          field: "projectState",
          valueFormatter: col => col.value,
          width: 50,
          cellRendererFramework: "CellRendererStatus"
        },
        {
          headerName: "Actions",
          field: "transactions",
          width: 70,
          cellRendererFramework: "CellRendererActions"
        }
      ],
      components: {
        CellRendererActions
      }
    };
  },
  apollo: {
    vacancyProjectPage: {
      query: gql`
        query Jobs($page: Int!, $size: Int, $filter: VacancyProjectFilter) {
          vacancyProjectPage(page: $page, size: $size, filter: $filter) {
            total
            results {
              id
              number
              title
              projectState
              company {
                id
                name
              }
              projectStage {
                id
                name
              }
            }
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        return {
          page: this.currentPage,
          size: this.paginationPageSize,
          filter: {
            state: this.filter.state,
            recruitment: this.filter.recruitment,
            consultant: this.filter.consultant,
            company: this.filter.company,
            userGroup: this.filter.userGroup,
            occupation: this.filter.occupation,
            skillJobType: this.filter.skillJobType,
            jobType: this.filter.jobType,
            searchQuery: this.searchQuery,
            projectStage: this.filter.projectStage
          }
        };
      }
    }
  },
  methods: {
    clearFilter() {
      this.filter = {};
      this.$children[0].$children[0].$children.forEach(element => {
        element.internalValue = null;
      });
    }
  }
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
